export default __webpack_public_path__ + "static/media/icon-right-arrow-blue.92fea93e.svg";